import { ErrorMessage } from "formik";
import { useEffect, useState, useContext } from "react";
import { getAllCountries } from "../../../service/MainService";
import { AppContext } from "../../../context/AppContext";

const CountrySelect = () => {
  const { selectedCountry, setSelectedCountry } = useContext(AppContext);
  const [country, setCountry] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const CountryList = await getAllCountries();
        setCountry(CountryList);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
  };

  return (
    <div>
      <label
        htmlFor="country"
        className="block text-sm font-medium leading-6 text-gray-500"
      >
        Country <span className="text-red-500">*</span>
      </label>
      <select
        name="Country"
        value={selectedCountry}
        onChange={handleCountryChange}
        className="w-full border border-gray-300 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
      >
        <option value="" disabled>
          Select an option
        </option>
        {country.map((option) => (
          <option key={option.CountryId} value={option.CountryId}>
            {option.CountryName}
          </option>
        ))}
      </select>
      <ErrorMessage
        name="Country"
        component="div"
        className="text-red-500 text-xs"
      />
    </div>
  );
};
export default CountrySelect;
